import React from 'react'


export default () => {
    return ( <img className='logo' src="/img/logo-wo-tag.png" alt='Logo' /> );
}